module.exports = __webpack_public_path__ + "img/eyebrow-2.29f83bfc.svg";